export default __webpack_public_path__ + "static/media/GoogleSans-Bold.9102333f.ttf";